import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useSellerInfoService = () => {
  const params = useCatalogProductIdParams();
  const { product, shop, brand_home } = usePdpBaseInfo(params);

  const is_overseas_direct_purchase = Boolean(product.trait_list?.find((o) => o.type === 'OVERSEAS_DIRECT_PURCHASE'));
  const is_hide = !brand_home || is_overseas_direct_purchase;

  return { shop, is_hide };
};
